import { Event } from '@/modules/tracking/types'
import AddToCartButtonEvents from '@/modules/tracking/events/helper/addToCartButton'

export default class StartPageEvent extends Event {
  static readonly AddToCart: AddToCartButtonEvents = {
    addToCart: new StartPageEvent('Produkt zum Warenkorb hinzugefügt'),
    quoteRequest: new StartPageEvent('Produkt per Angebotsfunktion angefragt'),
    emailRequest: new StartPageEvent('Produkt per E-Mail angefragt')
  }

  constructor(action: string, label?: string) {
    super('Startseite', action, label ?? '')
  }
}
